import { EntityType } from "@mapmycustomers/shared/enum";
import type { Activity } from "@mapmycustomers/shared/types/entity";

import type { WordCloudNote } from "@app/scene/dashboard/store/wordCloud/actions";

// Account wins over contact, contact over deal, when an activity has several.
const getActivityRelatedEntity = ({
  account,
  contact,
  deal,
}: Pick<Activity, "account" | "contact" | "deal">): WordCloudNote["relatedEntity"] => {
  if (account) {
    return { id: account.id, name: account.name, type: EntityType.COMPANY };
  }
  if (contact) {
    return { id: contact.id, name: contact.name, type: EntityType.PERSON };
  }
  if (deal) {
    return { id: deal.id, name: deal.name, type: EntityType.DEAL };
  }
  return undefined;
};

export default getActivityRelatedEntity;
